function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.2186 3L4 9.14571V22.6714H10.4286V12.3857H15.5714V22.6714H22V8.85L13.2186 3Z",
  fill: "currentColor"
});
function SvgPlacowka(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.2/media/placowka.4a5340fe.svg";
export { SvgPlacowka as ReactComponent };